<!-- 题库选题组件 -->
<template>
  <el-dialog
    title="选择题库"
    v-if="seeQuestionShow"
    :append-to-body="true"
    :visible.sync="seeQuestionShow"
    width="1140px"
    custom-class="q-question-dialog"
  >
    <span slot="title">
      <i class="el-icon-s-check" style="margin-right: 10px; color: #67c23a"></i
      >选择题库
    </span>
    <div class="q-filter">
      <el-input
        class="q-filter__stem"
        placeholder="请输入题干名称"
        v-model="searchQ.questionStem"
        clearable
        @keyup.enter.native="onSearch"
      >
        <i slot="prefix" class="el-input__icon el-icon-search"></i>
      </el-input>
      <label>归属课程：</label>
      <el-input
        class="q-filter__course"
        :value="courseNameText"
        disabled
        placeholder="当前课程"
      >
        <i slot="prefix" class="el-icon-lock" style="color: #909399"></i>
      </el-input>
      <label>归属章节：</label>
      <el-select
        clearable
        filterable
        class="q-filter__chapter"
        v-model="searchQ.teacherOpenCourseMergeCourseInfoId"
        placeholder="请选择归属章节"
        no-data-text="该课程暂无章节目录"
        @change="onChapterChange"
      >
        <el-option
          v-for="(item, index) in chapterList"
          :key="index"
          :label="item.courseInfoName"
          :value="item.teacherOpenCourseMergeCourseInfoId"
        ></el-option>
      </el-select>
      <label>题型：</label>
      <el-select
        clearable
        class="q-filter__type"
        v-model="searchQ.questionType"
        placeholder="请选择题型"
        @change="onTypeChange"
      >
        <el-option label="单选题" value="1"></el-option>
        <el-option label="多选题" value="2"></el-option>
        <el-option label="判断题" value="3"></el-option>
        <el-option label="填空题" value="4"></el-option>
        <el-option label="分析题" value="5"></el-option>
      </el-select>
      <el-button type="primary" icon="el-icon-search" @click="onSearch"
        >搜索</el-button
      >
      <el-button type="danger" @click="clearSelect">清除已选</el-button>
    </div>
    <el-table
      :data="newTabledata"
      border
      :row-key="getRowKeys"
      ref="multipleTable"
      @selection-change="questionChange"
      style="width: 100%; margin-top: 10px"
    >
      <el-table-column
        type="selection"
        width="50"
        :reserve-selection="true"
        header-align="center"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="questionStem"
        header-align="center"
        align="left"
        label="题干"
      >
        <template slot-scope="scope">
          <el-row v-html="$getReplace(scope.row.questionStem)"></el-row>
        </template>
      </el-table-column>
      <el-table-column
        prop="questionType"
        header-align="center"
        align="center"
        label="题型"
        width="100px"
      >
        <!-- (1单选 2多选 3判断) -->
        <template slot-scope="scope">
          {{ $retQuestionType(scope.row.questionType) }}
        </template>
      </el-table-column>
      <el-table-column
        prop="teacherOpenCourseIdText"
        header-align="center"
        align="center"
        label="归属课程"
        width="130px"
      >
      </el-table-column>
      <el-table-column
        prop="teacherOpenCourseMergeCourseInfoIdText"
        header-align="center"
        align="center"
        width="130px"
        label="归属章节"
      >
      </el-table-column>
    </el-table>
    <div
      class="block"
      style="
        text-align: right;
        bottom: 0;
        width: 96%;
        margin: 20px;
        position: relative;
      "
    >
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        background
        :hide-on-single-page="true"
        layout="sizes, prev, pager, next,jumper"
        :total="total"
      >
      </el-pagination>
      <p style="position: absolute; left: 0; top: 0">
        已选题目：{{ getSeeNum() }}
      </p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="seeQuestionShow = false">取 消</el-button>
      <el-button type="primary" @click="submitSeeQuestion">确 认</el-button>
    </span>
  </el-dialog>
</template>
<script>
import {
  getCourseList,
  getQuestionList,
  getCourseInfoList,
} from "@/common/getInfo"; //加载数据
export default {
  name: "question",
  props: {
    handsOnId: {
      type: String,
      default: function () {
        return null;
      },
    },
    courseId: {
      type: String,
      default: function () {
        return "";
      },
    },
    show: {
      type: Boolean,
      default: function () {
        return null;
      },
    },
    onIds: {
      type: String,
      default: function () {
        return "";
      },
    },
  },
  data() {
    return {
      seeQuestionShow: this.show,
      newTabledata: [],
      total: 0,
      limit: 10,
      page: 1,
      // 字段先全部声明，保证 Vue2 下是响应式的（后期新增 key 不触发更新）
      searchQ: {
        questionStem: "",
        teacherOpenCourseMergeCourseInfoId: "",
        questionType: "",
      },
      currentCourseName: "", //当前进入的课程名称（自动锁定，不再提供选择）
      chapterList: [],
      oldNum: 0,
      selections: {}, //存储选中行的数据
      ids: "",
    };
  },
  created() {
    this.getInfo();
  },
  computed: {
    courseNameText() {
      return this.$isEmpty(this.currentCourseName)
        ? "当前课程"
        : this.currentCourseName;
    },
  },
  mounted() {},
  methods: {
    handleSizeChange(val) {
      this.limit = val;
      this.getQuestionList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getQuestionList();
    },
    submitSeeQuestion() {
      //获取选中的行的id值
      let selections = Object.keys(this.selections);
      //由于Object.keys之后是字符串类型， 如果传递给后台的id是数字类型,需要转换过来。
      let ids = this.ids;
      let one = ids.charAt(0);
      let last = ids.charAt(ids.length - 1);
      ids = ids.substring(
        one == "," ? 1 : 0,
        last == "," ? ids.length - 1 : ids.length
      ); //去掉前后逗号
      // if(this.$isEmpty(ids)){
      //   this.$message({message: '请选择题目！',type: 'warning'});
      //   return;
      // }
      this.seeQuestionShow = false;
      if (!this.$isEmpty(ids)) {
        this.$message({ type: "success", message: "选择成功！" });
      }
      this.$emit("onSuccess", ids); //成功的回调 返回ids字符串
    },
    getInfo() {
      this.ids = this.$isEmpty(this.onIds) ? "" : "," + this.onIds + ",";
      this.resetSearch();
      this.getCourseName();
      this.getChapterList();
      this.getQuestionList();
    },
    resetSearch() {
      //重置筛选项（字段必须保留，否则 Vue2 新增 key 不具备响应性）
      this.searchQ = {
        questionStem: "",
        teacherOpenCourseMergeCourseInfoId: "",
        questionType: "",
      };
    },
    getQuestionList() {
      // 显式拼参数：原先 Object.assign(this.searchQ, param) 会让默认课程ID覆盖筛选值，导致筛选失效
      let param = {
        // handsOnId:this.handsOnId,
        page: this.page,
        limit: this.limit,
        questionStatus: 1,
        // 归属课程已锁定为进入时的课程，不再支持切换
        teacherOpenCourseId: this.courseId,
        teacherOpenCourseMergeCourseInfoId: this.$isEmpty(
          this.searchQ.teacherOpenCourseMergeCourseInfoId
        )
          ? undefined
          : this.searchQ.teacherOpenCourseMergeCourseInfoId,
        questionStem: this.$isEmpty(this.searchQ.questionStem)
          ? undefined
          : this.searchQ.questionStem,
        questionType: this.$isEmpty(this.searchQ.questionType)
          ? undefined
          : this.searchQ.questionType,
      };
      getQuestionList(param).then((ret) => {
        if (ret.code == 0) {
          this.total = Number(ret.count);
          this.newTabledata = ret.data;
          this.fillCourseNameFromRows();
          setTimeout(() => {
            if (!this.$isEmpty(this.ids)) {
              for (let i in this.newTabledata) {
                //判断是否存在
                if (
                  this.ids.indexOf(
                    "," +
                      this.newTabledata[i]
                        .teacherOpenCourseMergeResourcesQuestionId +
                      ","
                  ) >= 0
                ) {
                  this.$refs.multipleTable.toggleRowSelection(
                    this.newTabledata[i],
                    true
                  ); //选中
                }
              }
            }
          }, 10);
        } else {
          this.$message({ message: ret.msg, type: "error" });
        }
      });
    },
    getCourseName() {
      //获取当前课程名称：归属课程已锁定，仅用于展示，不提供选择
      if (this.$isEmpty(this.courseId)) {
        return;
      }
      getCourseList()
        .then((ret) => {
          if (ret.code == 0 && ret.data && ret.data.length > 0) {
            for (let i = 0; i < ret.data.length; i++) {
              if (ret.data[i].teacherOpenCourseId == this.courseId) {
                this.currentCourseName =
                  ret.data[i].teacherOpenCourseIdText ||
                  ret.data[i].teacherOpenCourseTitle ||
                  "";
                break;
              }
            }
          }
        })
        .catch(() => {
          //课程名拿不到时用列表数据兜底，不打断主流程
        });
    },
    fillCourseNameFromRows() {
      //兜底：从题目列表行里取归属课程名称（每题都带 teacherOpenCourseIdText）
      if (!this.$isEmpty(this.currentCourseName)) {
        return;
      }
      let rows = this.newTabledata || [];
      for (let i = 0; i < rows.length; i++) {
        if (
          rows[i].teacherOpenCourseId == this.courseId &&
          !this.$isEmpty(rows[i].teacherOpenCourseIdText)
        ) {
          this.currentCourseName = rows[i].teacherOpenCourseIdText;
          return;
        }
      }
    },
    getChapterList() {
      //获取归属章节：课程已锁定，直接取当前课程的章节
      if (this.$isEmpty(this.courseId)) {
        this.chapterList = [];
        return;
      }
      getCourseInfoList({ teacherOpenCourseId: this.courseId }).then((ret) => {
        this.chapterList = ret.code == 0 && ret.data ? ret.data : [];
      });
    },
    onSearch() {
      //点击搜索：回到第一页重新查询
      this.page = 1;
      this.getQuestionList();
    },
    onChapterChange() {
      //切换章节：立即查询（与题型保持一致，不需要再点搜索）
      this.page = 1;
      this.getQuestionList();
    },
    onTypeChange() {
      //切换题型：立即查询
      this.page = 1;
      this.getQuestionList();
    },
    closeDialog() {
      //关闭时调用
      this.seeQuestionShow = false;
      this.$emit("close");
    },
    getRowKeys(row) {
      return row.teacherOpenCourseMergeResourcesQuestionId;
    },
    questionChange(val) {
      //表格内checkbox触发的全选按钮状态变化
      let onIds = "";
      val.forEach((item, i) => {
        //将选择的ID拼接起来
        onIds += item.teacherOpenCourseMergeResourcesQuestionId;
        if (i < val.length - 1) {
          onIds += ",";
        }
      });
      //根据选择的onIds判断哪些是新增的，哪些不是新增的
      this.newTabledata.forEach((item, i) => {
        setTimeout(() => {
          //所有已选不存在当前
          if (
            this.ids.indexOf(
              "," + item.teacherOpenCourseMergeResourcesQuestionId + ","
            ) < 0
          ) {
            //已经存在当前选择的
            if (
              ("," + onIds + ",").indexOf(
                "," + item.teacherOpenCourseMergeResourcesQuestionId + ","
              ) >= 0
            ) {
              if (this.$isEmpty(this.ids)) {
                this.ids +=
                  "," + item.teacherOpenCourseMergeResourcesQuestionId + ",";
              } else {
                this.ids +=
                  item.teacherOpenCourseMergeResourcesQuestionId + ",";
              }
            }
          } else {
            //所有已选存在当前
            if (
              ("," + onIds + ",").indexOf(
                "," + item.teacherOpenCourseMergeResourcesQuestionId + ","
              ) < 0
            ) {
              this.ids = this.ids.replace(
                "," + item.teacherOpenCourseMergeResourcesQuestionId + ",",
                ","
              );
              if (this.ids == ",") {
                this.ids = "";
              }
            }
          }
        }, 100);
      });
    },
    // 清空选择的值
    clearSelect() {
      this.ids = "";
      this.$refs.multipleTable.clearSelection();
    },
    getSeeNum() {
      //获取选择的题目数量
      let i = this.ids.split(",").length;
      if (i >= 3) {
        return i - 2;
      } else {
        return i == 1 ? 0 : 1;
      }
    },
  },
  watch: {
    show: {
      handler(newName) {
        this.seeQuestionShow = newName;
        this.getInfo();
      },
      immediate: true,
    },
  },
};
</script>

<style lang="less">
// 小屏（如 1024/1280 宽）兜底：弹窗不超出视口，筛选区自动换行
.q-question-dialog {
  max-width: 96vw;
}

.q-filter {
  display: flex;
  flex-wrap: wrap;
  align-items: center;

  .q-filter__stem {
    width: 175px;
  }
  .q-filter__course {
    width: 150px;

    // 归属课程为锁定状态，做成"只读展示"的观感，避免用户以为还能选
    .el-input__inner {
      background-color: #f4f6f8;
      color: #606266;
      cursor: default;
    }
  }
  .q-filter__chapter {
    width: 150px;
  }
  .q-filter__type {
    width: 105px;
  }

  > * {
    margin-right: 10px;
    margin-bottom: 8px;
  }

  label {
    white-space: nowrap;
  }

  .el-button + .el-button {
    margin-left: 0;
  }
}

.language_points {
  p {
    margin: 0;
    line-height: 25px;
    text-indent: 2em;
  }
  table {
    width: 100%;
    border-collapse: collapse;
  }
  tr,
  td {
    border: 1px solid #ebeef5;
    text-align: center;
    line-height: 40px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Question/index.vue